import { z } from 'zod';
import { IntegrationStatusSchema, ModuleKey, OrgId, UnixTimestamp, UserId, nowUnix, } from '@triedge/domain-core';
const MAX_PAYLOAD_BYTES = 400_000;
export const ModuleConfigPayloadSchema = z.string().max(MAX_PAYLOAD_BYTES);
export const ModuleConfigVersionSchema = z.number().int().nonnegative();
export const ModuleConfigSchema = z.object({
    orgId: OrgId,
    moduleKey: ModuleKey,
    version: ModuleConfigVersionSchema,
    payload: ModuleConfigPayloadSchema,
    integrationStatus: IntegrationStatusSchema,
    updatedAt: UnixTimestamp,
    updatedBy: UserId.optional(),
}).passthrough();
export const ModuleConfigUpdateInputSchema = z.object({
    orgId: OrgId,
    moduleKey: ModuleKey,
    payload: ModuleConfigPayloadSchema,
    integrationStatus: IntegrationStatusSchema,
    updatedBy: UserId.optional(),
    updatedAt: UnixTimestamp.optional(),
});
export const ModuleConfigEventSchema = z.object({
    type: z.literal('module-config.updated'),
    orgId: OrgId,
    moduleKey: ModuleKey,
    version: ModuleConfigVersionSchema,
    updatedAt: UnixTimestamp,
    updatedBy: UserId.optional(),
}).passthrough();
const assertNever = (value) => {
    throw new Error(`Unhandled action: ${JSON.stringify(value)}`);
};
export const reduceModuleConfig = (state, action) => {
    switch (action.type) {
        case 'module_config_updated': {
            const currentVersion = state?.version ?? 0;
            const updatedAt = action.payload.updatedAt ?? nowUnix();
            const nextState = ModuleConfigSchema.parse({
                ...action.payload,
                version: currentVersion + 1,
                updatedAt,
            });
            const event = ModuleConfigEventSchema.parse({
                type: 'module-config.updated',
                orgId: nextState.orgId,
                moduleKey: nextState.moduleKey,
                version: nextState.version,
                updatedAt: nextState.updatedAt,
                updatedBy: nextState.updatedBy,
            });
            return { nextState, events: [event] };
        }
        default:
            return assertNever(action);
    }
};
//# sourceMappingURL=module-config.js.map